import { render, staticRenderFns } from "./SearchItemSkeleton.vue?vue&type=template&id=25f16d04&scoped=true&"
var script = {}
import style0 from "./SearchItemSkeleton.vue?vue&type=style&index=0&id=25f16d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f16d04",
  null
  
)

export default component.exports